'use client';
import styled from 'styled-components';

export const Wrapper = styled.div`
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  opacity: 0.5;
`;
